import { ReviewStats } from "./components/ReviewStats";
import { TestimonialCard } from "./components/TestimonialCard";
import { TrustedByLogos } from "./components/TrustedByLogos";

export const Testimonials = () => (
  <div className="space-y-12">
    <TestimonialCard />
    <ReviewStats />
    <TrustedByLogos />
  </div>
);
